import actions from '@/store/modules/user/actions.js'
import getters from '@/store/modules/user/getters.js'
import mutations from '@/store/modules/user/mutations.js'

/**
 * @returns {object}
 */
const getDefaultState = () => ({
  user: null,
  permissions: [],
  selectedGroupId: localStorage.getItem('stitch:df:selectedGroupId'),
  seasons: [],
  selectedSeasonId: localStorage.getItem('stitch:df:selectedSeasonId'),
  invites: []
})

export default {
  actions,
  getters,
  mutations,
  state: getDefaultState()
}

export { getDefaultState }
